<template>
  <div class="add-product-container">
    <loader :loading="loading" v-if="loading" />
    <div class="add-product-wrapper" v-else>
      <div class="row p-2">

           <div class="col-md-6 col-12">
            <primary-input
                type="text"
                name="product name"
                class="name-input"
                v-validate="'required'"
                v-model="product.product_name"
                :class="{'input': true, 'is-danger': errors.has('product name')}"
                placeholder="Enter product name"
            />
            <div
                class="help is-danger"
                v-if="errors.has('product name')"
            >{{ errors.first('product name') }}</div>
          </div>
           <div class="col-md-6 col-12">
            <primary-select
                type="text"
                name="status"
                class="status"
                v-validate="'required'"
                v-model="product.status"
                :class="{'input': true, 'is-danger': errors.has('status')}"
                placeholder="Select"
                :options="statusTypes"
            />
            <div v-if="errors.has('status')" class="help is-danger">{{ errors.first('status') }}</div>
          </div>
           <div class="col-md-6 col-12">
          <primary-select
            type="text"
            name="type"
            v-validate="'required'"
            v-model="product.public"
            :class="{'input': true, 'is-danger': errors.has('type')}"
            placeholder="Select"
            :options="types"
          />
          <div v-if="errors.has('type')" class="help is-danger">{{ errors.first('type') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";

export default {
  name: 'AddProduct',
  components: {
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    OperatorComponent: () => import("./AddProductOperator.vue"),
    VendorComponent: () => import("./AddProductVendor.vue"),
    Loader: () => import("@/components/Loader.vue"),

  },
  data: () => ({
    country_list: [],
    statusTypes: [{ name: 'Active', value: 'active' }, { name: 'Inactive', value: 'inactive' }],
    types: [{ name: 'Public', value: true }, { name: 'Private', value: false }],
    loading: false,

  }),
  computed: {
    ...mapGetters({
      product: 'products/getProduct',
    }),  
  },
  created() {
  },
  methods: {
    ...mapActions({
      addProduct: 'products/addProduct',
    }),
    postProduct: async function() {
      await this.addProduct(this.product);
    },
    save:async function() {
      const valid = await this.$validator.validate();
      if (!valid) { return { isProductAdded: false } }

      try {
        this.loading = true;
        this.postProduct();
        this.$success("Product has been added.");
            return { isProductAdded: true };
      
      } catch (err) { 
        this.$error(err);
        return { isProductAdded: false };
      }
    },
    validate:async function() {
      const valid = await this.$validator.validate();

      if (!valid) { return }
    }
  },
};
</script>

<style lang="scss" scoped>
.add-product-container {
  height: fit-content;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 130px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-product-wrapper {
    display: flex;
    padding: 15px 15px 15px 15px;
    box-sizing: border-box;
    width: 100%;
    height: fit-content;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    flex-direction: column;
    // align-items: center;
    // height: fit-content;
    // background-color: #ffffff;
    // padding-top: 15px;
    .title {
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      margin-bottom: 15px;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        width: 100%;
        margin-right: 15px;
        padding-left: 0;
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .status {
          margin-top: 20px;
        }
      }
    }
    .section-one {
      width: 60%;
      .title {
        color: #000000;
        font-family: "Helvetica Neue";
        font-size: 18px;
        font-weight: 500;
        line-height: 30px;
        margin-bottom: 15px;
      }
      .name-input {
        width: calc(100% - 55px);
        margin-bottom: 30px;
      }
      .create-operator {
        cursor: pointer;
        margin-top: 20px;
        margin-bottom: 10px;
        height: 30px;
        width: fit-content;
        fill: #55616e;
        display: flex;
        align-items: center;
        align-self: flex-start;
        p {
          margin-left: 7px;
          margin-bottom: 0;
          color: #55616e;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
        }
      }
      .active {
        background: #f8f9fe;
      }
    }
    .section-two {
      width: 40%;
      padding: 15px;
      box-sizing: border-box;
      background-color: #f8f9fe;
      .title {
        color: #bdbfd8;
        font-family: "Helvetica Neue";
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 30px;
      }
      .vendor-container {
        display: flex;
        width: 100%;
        margin-bottom: 10px;
        .vendor-wrapper {
          display: flex;
          width: calc(100% - 55px);
          justify-content: space-between;
          .vendor-select {
            width: 60%;
          }
          .vendor-input {
            width: 37%;
          }
        }
        .close-button {
          display: flex;
          align-items: center;
          width: 55px;
          justify-content: center;
          fill: #55616e;
          svg {
            cursor: pointer;
          }
        }
      }
      .create-operator {
        cursor: pointer;
        margin-top: 20px;
        margin-bottom: 10px;
        height: 30px;
        width: fit-content;
        fill: #55616e;
        display: flex;
        align-items: center;
        align-self: flex-start;
        p {
          margin-left: 7px;
          margin-bottom: 0;
          color: #55616e;
          font-family: "Helvetica Neue";
          font-size: 14px;
          line-height: 25px;
        }
      }
    }
  }
}
.row .input{
  margin-top: 20px;
}
    .help.is-danger {
        position: absolute;
    }
</style>

